import { Link } from 'react-router';
import { Button, classesBouton } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { reserveApi, useMutationReserve, useRangement } from '../../api/reserve.js';
import { estApiError } from '../../api/errors.js';
import { galerieALaction } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { Etiquettes } from './Etiquettes.js';
import styles from './InventairePage.module.css';

export function RangementOeuvre({ oeuvreId }: { oeuvreId: string }) {
  const { t } = useTranslation(['regie', 'commun']);
  const { galerieSlug, galerie } = useShellContext();
  const fiche = useRangement(galerieSlug, oeuvreId);
  const retrouvee = useMutationReserve(galerieSlug, (id: string, appel) =>
    reserveApi.retrouvee(galerieSlug, id, appel),
  );
  const r = fiche.data;
  return (
    <section className={styles.panneau} aria-label={t('regie:inventaire.rangement')}>
      <h2>{t('regie:inventaire.rangement')}</h2>
      {fiche.isPending && <p role="status">{t('commun:chargement')}</p>}
      {fiche.isError && <p role="alert">{t('commun:erreurReseau')}</p>}
      {r && (
        <div className={styles.formulaire}>
          <p>
            {t('regie:inventaire.emplacement')} : {r.emplacement?.chemin ?? '—'}
          </p>
          <p>
            {t('regie:inventaire.caisse')} :{' '}
            {r.caisse ? (
              <Link to={`/${galerieSlug}/inventaire/caisses/${r.caisse.id}`}>
                {r.caisse.numero}
              </Link>
            ) : (
              '—'
            )}
          </p>
          <p>
            {t('regie:inventaire.etiquette')} : {r.etiquette ? `ART:${r.etiquette.jeton}` : '—'}
          </p>
          <Etiquettes cibles={[{ type: 'oeuvre', id: oeuvreId }]} />
          {galerieALaction(galerie, 'inventaire:write') && (
            <Link
              className={classesBouton('secondary', 'sm')}
              to={`/${galerieSlug}/inventaire?onglet=ranger`}
            >
              {t('regie:inventaire.ranger')}
            </Link>
          )}
          {r.introuvable && (
            <div>
              <p className={styles.erreur}>
                {t('regie:inventaire.introuvable')} : {r.introuvable.note}
              </p>
              {galerieALaction(galerie, 'inventaire:write') && (
                <Button
                  disabled={retrouvee.isPending}
                  onClick={() => retrouvee.mutate(r.introuvable!.id)}
                >
                  {t('regie:inventaire.retrouvee')}
                </Button>
              )}
            </div>
          )}
          {retrouvee.error && (
            <p role="alert">
              {estApiError(retrouvee.error) ? retrouvee.error.message : t('commun:erreurReseau')}
            </p>
          )}
        </div>
      )}
    </section>
  );
}
